/* eslint-disable react-hooks/exhaustive-deps, no-unused-vars, eqeqeq, no-lone-blocks */
import logger from '../../utils/logger';
import React, { useState, useCallback, useMemo, useEffect, useRef, useContext } from 'react';
import {
  addEdge,
  SmoothStepEdge,
  BezierEdge,
  StraightEdge,
  MarkerType,
  ConnectionMode,
  ConnectionLineType,
  ReactFlowProvider,
  useReactFlow,
} from '@xyflow/react';
import WaypointEdge from '../../all-node/edges/WaypointEdge';
import { v4 as uuidv4 } from 'uuid';
import ProcessMapFlow from './components/ProcessMapFlow';
import '@xyflow/react/dist/style.css';
import { applyNodeChanges, applyEdgeChanges } from '@xyflow/react';
import Header from '../../components/Header';
import { useNavigate, useParams } from 'react-router-dom';
import api, {
  checkParentPublishRecords,
  checkPublishRecord,
  addFavProcess,
  removeFavProcess,
} from '../../api/api';
import SwimlaneArrowBoxNode from '../../all-node/swimlane-nodes/SwimlaneArrowBoxNode';
import SwimlaneBoxNode from '../../all-node/swimlane-nodes/SwimlaneBoxNode';
import SwimlaneDiamondNode from '../../all-node/swimlane-nodes/SwimlaneDiamondNode';
import SwimlaneRightsideBox from '../../all-node/swimlane-nodes/SwimlaneRightsideBox';
import FreeTextNode from '../../all-node/swimlane-nodes/FreeTextNode';
import styles from './SwimlaneStyles';
import { BreadcrumbsContext } from '../../context/BreadcrumbsContext';
import '../../css/Swimlane.css';
import { useSelector } from 'react-redux';
import StickyNote from '../../all-node/process-map-nodes/StickyNote';
import useCheckFavorite from '../../hooks/useCheckFavorite';
import { useTranslation } from '../../hooks/useTranslation';
import CustomAlert from '../../components/CustomAlert';
import { useLangMap } from '../../hooks/useLangMap';
import { getLevelKey } from '../../utils/getLevel';
import { useSwimlaneLabelChange } from '../../hooks/swimlane/useSwimlaneLabelChange';
import { useSwimlaneFetchNodes } from '../../hooks/swimlane/useSwimlaneFetchNodes';
import { useProcessNavigation } from '../../hooks/useProcessNavigation';
import EdgeContextMenu from '../../components/EdgeContextMenu';
// import ExistingModelPopup from '../../components/ExistingModelPopup';
// import ExistingRolePopup from '../../components/ExistingRolePopup';
// import ManageRoleGroupModal from './components/ManageRoleGroupModal';
// import AssignRoleOwnerModal from './components/AssignRoleOwnerModal';

// NEW IMPORTS
import { getDropdownPosition, centerChildInParent } from '../../utils/swimlaneUtils';
import { useSwimlaneDrag } from '../../hooks/swimlane/useSwimlaneDrag';
import { useSwimlaneAddNode } from '../../hooks/swimlane/useSwimlaneAddNode';
import YesNode from '../../all-node/swimlane-nodes/YesNode';
import NoNode from '../../all-node/swimlane-nodes/NoNode';
// import PublishPopup from '../../components/PublishPopup';
// import EditorialChangePopup from '../../components/EditorialChangePopup';
// import ContentChangePopup from '../../components/ContentChangePopup';
// CUSTOM REFAC HOOKS
import { useSwimlaneModelState } from './hooks/useSwimlaneModelState';
import { useSwimlaneModelHandlers } from './hooks/useSwimlaneModelHandlers';
import { useFetchVersions } from '../../hooks/useFetchVersions';
import { useReconstructBreadcrumbs } from '../../hooks/useReconstructBreadcrumbs';
import { useApprovalStatus } from '../../hooks/useApprovalStatus';
import { useSwimlaneVersionData } from './hooks/useSwimlaneVersionData';
import { useSwimlaneApprovals } from './hooks/useSwimlaneApprovals';
import { SwimlaneModals } from './components/SwimlaneModals';
import useEnergyMeter from '../../hooks/useEnergyMeter';
import GenerateNodesAndEdges from '../../all-node/swimlane-nodes/GenerateNodesAndEdges';

const getOutwardDirection = (position) => {
  switch (position) {
    case 'top':
      return { x: 0, y: -1 };
    case 'right':
      return { x: 1, y: 0 };
    case 'bottom':
      return { x: 0, y: 1 };
    case 'left':
      return { x: -1, y: 0 };
    default:
      return { x: 0, y: 0 };
  }
};

const getOrthogonalPath = (sourceX, sourceY, sourcePosition, targetX, targetY, targetPosition) => {
  const STUB_LENGTH = 20;

  const targetPos =
    targetPosition ||
    (sourcePosition === 'left'
      ? 'right'
      : sourcePosition === 'right'
        ? 'left'
        : sourcePosition === 'top'
          ? 'bottom'
          : 'top');

  const sourceDir = getOutwardDirection(sourcePosition);
  const targetDir = getOutwardDirection(targetPos);

  // Compute stub lengths
  let sourceStubLength = STUB_LENGTH;
  if (sourceDir.x !== 0 && targetDir.x !== 0) {
    if (sourceDir.x * targetDir.x < 0) {
      const gap = (targetX - sourceX) * sourceDir.x;
      if (gap > 0) {
        sourceStubLength = Math.max(5, Math.min(STUB_LENGTH, gap / 2));
      }
    }
  }
  if (sourceDir.y !== 0 && targetDir.y !== 0) {
    if (sourceDir.y * targetDir.y < 0) {
      const gap = (targetY - sourceY) * sourceDir.y;
      if (gap > 0) {
        sourceStubLength = Math.max(5, Math.min(STUB_LENGTH, gap / 2));
      }
    }
  }
  const targetStubLength = sourceStubLength;
  const effectiveSourceStubLength =
    sourcePosition === 'top' ? Math.min(sourceStubLength, Math.max(2, sourceY)) : sourceStubLength;
  const effectiveTargetStubLength =
    targetPos === 'top' ? Math.min(targetStubLength, Math.max(2, targetY)) : targetStubLength;

  const sourceStub = {
    x: sourceX + sourceDir.x * effectiveSourceStubLength,
    y: Math.max(0, sourceY + sourceDir.y * effectiveSourceStubLength),
  };

  const targetStub = {
    x: targetX + targetDir.x * effectiveTargetStubLength,
    y: Math.max(0, targetY + targetDir.y * effectiveTargetStubLength),
  };

  const P = [{ x: sourceX, y: sourceY }, sourceStub, targetStub, { x: targetX, y: targetY }];

  const pts = [P[0]];

  for (let i = 0; i < P.length - 1; i++) {
    const p1 = P[i];
    const p2 = P[i + 1];

    const dx = p2.x - p1.x;
    const dy = p2.y - p1.y;

    if (Math.abs(dx) < 0.01 && Math.abs(dy) < 0.01) {
      continue;
    }

    if (Math.abs(dx) < 0.01) {
      pts.push({ x: p2.x, y: p2.y });
    } else if (Math.abs(dy) < 0.01) {
      pts.push({ x: p2.x, y: p2.y });
    } else {
      let segmentGoHorizontalFirst = true;
      if (i === 0) {
        // From source to sourceStub
        if (sourcePosition === 'left') {
          segmentGoHorizontalFirst = dx <= 0;
        } else if (sourcePosition === 'right') {
          segmentGoHorizontalFirst = dx >= 0;
        } else if (sourcePosition === 'top') {
          segmentGoHorizontalFirst = dy > 0;
        } else if (sourcePosition === 'bottom') {
          segmentGoHorizontalFirst = dy < 0;
        }
      } else if (i === 1) {
        // From sourceStub to targetStub (the diagonal we want to bend)
        // We use sourcePosition to guide the initial bend
        if (sourcePosition === 'left' || sourcePosition === 'right') {
          segmentGoHorizontalFirst = true;
        } else {
          segmentGoHorizontalFirst = false;
        }
      } else {
        // From targetStub to target
        if (targetPos === 'left' || targetPos === 'right') {
          segmentGoHorizontalFirst = false;
        } else {
          segmentGoHorizontalFirst = true;
        }
      }

      if (segmentGoHorizontalFirst) {
        pts.push({ x: p2.x, y: p1.y });
        pts.push({ x: p2.x, y: p2.y });
      } else {
        pts.push({ x: p1.x, y: p2.y });
        pts.push({ x: p2.x, y: p2.y });
      }
    }
  }

  return pts.map((p, index) => `${index === 0 ? 'M' : 'L'} ${p.x} ${p.y}`).join(' ');
};

const CustomConnectionLine = ({ fromX, fromY, fromPosition, toX, toY, toPosition }) => {
  const path = getOrthogonalPath(fromX, fromY, fromPosition, toX, toY, toPosition);
  return (
    <g>
      <path fill="none" stroke="#002060" strokeWidth={2.5} d={path} />
      <circle cx={toX} cy={toY} fill="#fff" r={3} stroke="#002060" strokeWidth={1.5} />
    </g>
  );
};

const SwimlaneModelContent = () => {
  const {
    mode,
    version,
    processId,
    level,
    parentId,
    pageTitle,
    user_id,
    currentParentId: routeParentId,
  } = useParams();
  const activeMode = version ? 'version' : mode || 'edit';
  const currentParentId =
    parentId ||
    (routeParentId && routeParentId !== 'null' && routeParentId !== 'undefined'
      ? routeParentId
      : null);

  useReconstructBreadcrumbs(activeMode === 'published' ? 'publish' : 'draft');
  const t = useTranslation();
  const navigate = useNavigate();
  const id = processId; // string
  const currentLevel = (() => {
    if (!level) return 0;
    if (String(level).startsWith('level')) {
      const match = String(level).match(/^level(\d+)/);
      return match ? parseInt(match[1], 10) : 0;
    }
    const parsed = parseInt(level, 10);
    return isNaN(parsed) ? 0 : parsed;
  })();
  const { goToProcess } = useProcessNavigation();
  const LoginUser = useSelector((state) => state.user.user);
  const safeRemainingHeight = 588;

  const langMap = useLangMap();

  const initialNodes = useMemo(
    () => GenerateNodesAndEdges(activeMode, safeRemainingHeight),
    [activeMode, safeRemainingHeight]
  );

  const state = useSwimlaneModelState(initialNodes);

  const {
    setWindowSize,
    title,
    Settitle,
    ParentPageGroupId,
    SetParentPageGroupId,
    showPublishPopup,
    setShowPublishPopup,
    showEditorialPopup,
    setShowEditorialPopup,
    showContentPopup,
    setShowContentPopup,
    user,
    setUser,
    position,
    setPosition,
    hasUnsavedChanges,
    setHasUnsavedChanges,
    options,
    setOptions,
    isPopupOpen,
    setIsPopupOpen,
    isCheckboxPopupOpen,
    setIsCheckboxPopupOpen,
    LinknodeList,
    setLinknodeList,
    isexistingroleCheckboxPopupOpen,
    setIsexistingroleCheckboxPopupOpen,
    LinkexistingRole,
    setLinkexistingRole,
    selectedLinknodeIds,
    setSelectedLinknodeIds,
    selectedexistigrolenodeId,
    setSelectedexistingrolenodeId,
    getDraftedDate,
    setDraftedDate,
    KeepOldPosition,
    setKeepOldPosition,
    isFavorite,
    setIsFavorite,
    process_img,
    setprocess_img,
    selectedTitle,
    setSelectedTitle,
    showTranslationPopup,
    setShowTranslationPopup,
    translationDefaults,
    setTranslationDefaults,
    selectedGroupId,
    setSelectedGroupId,
    ChildNodes,
    setChiledNodes,
    contextMenu,
    setContextMenu,
    MenuVisible,
    setMenuVisible,
    selectedNode,
    setSelectedNode,
    roleGroupEditData,
    setRoleGroupEditData,
    selectedNodeId,
    setSelectedNodeId,
    selectedNodefreetextId,
    setSelectedNodefreetextId,
    showVersionPopup,
    setShowVersionPopup,
    versionPopupPayload,
    setversionPopupPayload,
    processDefaultlanguage_id,
    setprocessDefaultlanguage_id,
    OriginalDefaultlanguge_id,
    setOriginalDefaultlanguge_id,
    supportedLanguages,
    setSupportedLanguages,
    selectedEdge,
    setSelectedEdge,
    getPublishedDate,
    setgetPublishedDate,
    revisionData,
    setrevisionData,
    detailschecking,
    setdetailschecking,
    nodes,
    setNodes,
    searchQuery,
    setSearchQuery,
    ExistingrolesearchQuery,
    setExistingrolesearchQuery,
    checkpublish,
    Setcheckpublish,
    showRoleGroupModal,
    setShowRoleGroupModal,
    showAssignOwnerModal,
    setShowAssignOwnerModal,
    activeRoleForOwner,
    setActiveRoleForOwner,
    selectedEdgeInfoForFreeText,
    setSelectedEdgeInfoForFreeText,
    edges,
    setEdges,
    isModalOpen,
    setIsModalOpen,
    modalText,
    setModalText,
    modalPosition,
    setModalPosition,
  } = state;

  useEffect(() => {
    setversionPopupPayload('');
  }, [processId, level, currentParentId, setversionPopupPayload]);

  const { screenToFlowPosition, setViewport, getViewport } = useReactFlow();
  const [drawingEdge, setDrawingEdge] = React.useState(null);

  // Ensure internal ReactFlow viewport transform never drifts from (0, 0, 1)
  const ensureZeroViewport = useCallback(() => {
    try {
      const vp = getViewport();
      if (vp && (vp.x !== 0 || vp.y !== 0 || vp.zoom !== 1)) {
        setViewport({ x: 0, y: 0, zoom: 1 });
      }
    } catch {
      // ignore
    }
  }, [getViewport, setViewport]);

  useEffect(() => {
    ensureZeroViewport();
  }, [ensureZeroViewport]);

  // Handle styling during drawing mode
  useEffect(() => {
    if (!drawingEdge) {
      document.querySelectorAll('.react-flow__handle').forEach((el) => {
        el.classList.remove('drawing-target-candidate');
      });
      return;
    }

    const updateHandles = () => {
      document.querySelectorAll('.react-flow__handle').forEach((el) => {
        const nodeId = el.getAttribute('data-nodeid');
        const isSourceNode = nodeId === drawingEdge.source;
        if (!isSourceNode) {
          el.classList.add('drawing-target-candidate');
        } else {
          el.classList.remove('drawing-target-candidate');
        }
      });
    };

    updateHandles();

    const observer = new MutationObserver(updateHandles);
    const container = document.querySelector('.react-flow__pane');
    if (container) {
      observer.observe(container, { childList: true, subtree: true });
    }

    return () => {
      observer.disconnect();
      document.querySelectorAll('.react-flow__handle').forEach((el) => {
        el.classList.remove('drawing-target-candidate');
      });
    };
  }, [drawingEdge]);

  // Set up custom unsaved changes event listener
  useEffect(() => {
    const handleUnsaved = () => setHasUnsavedChanges(true);
    window.addEventListener('unsavedChanges', handleUnsaved);
    return () => window.removeEventListener('unsavedChanges', handleUnsaved);
  }, [setHasUnsavedChanges]);

  // Track cursor position on mousemove when drawing
  useEffect(() => {
    if (!drawingEdge) return;

    const handleMouseMove = (e) => {
      const flowPos = screenToFlowPosition({ x: e.clientX, y: e.clientY });
      const snappedCursor = {
        x: Math.round(flowPos.x / 10) * 10,
        y: Math.round(flowPos.y / 10) * 10,
      };
      setDrawingEdge((prev) => {
        if (!prev) return null;
        return {
          ...prev,
          currentCursor: snappedCursor,
        };
      });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, [drawingEdge, screenToFlowPosition]);

  // ESC key and Right click (contextmenu) cancel drawing
  useEffect(() => {
    if (!drawingEdge) return;

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        e.stopPropagation();
        e.preventDefault();
        setDrawingEdge(null);
      }
    };

    const handleContextMenu = (e) => {
      e.stopPropagation();
      e.preventDefault();
      setDrawingEdge(null);
    };

    window.addEventListener('keydown', handleKeyDown, true);
    window.addEventListener('contextmenu', handleContextMenu, true);
    return () => {
      window.removeEventListener('keydown', handleKeyDown, true);
      window.removeEventListener('contextmenu', handleContextMenu, true);
    };
  }, [drawingEdge]);

  // Click handler for canvas (place waypoints) and handles (commit/cancel)
  useEffect(() => {
    if (!drawingEdge) return;

    const handleClick = (e) => {
      const handleEl = e.target.closest('.react-flow__handle');
      if (handleEl) {
        e.stopPropagation();
        e.preventDefault();

        const targetNodeId = handleEl.getAttribute('data-nodeid');
        const targetHandleId = handleEl.getAttribute('data-handleid');

        if (targetNodeId === drawingEdge.source) {
          setDrawingEdge(null);
          return;
        }

        const newEdgeId = `edge-${uuidv4().replace(/-/g, '').substring(0, 6)}`;
        const newEdge = {
          id: newEdgeId,
          source: drawingEdge.source,
          sourceHandle: drawingEdge.sourceHandle,
          target: targetNodeId,
          targetHandle: targetHandleId,
          type: 'waypointEdge',
          data: {
            waypoints: drawingEdge.waypoints,
          },
          markerEnd: {
            type: MarkerType.ArrowClosed,
            color: '#002060',
            width: 12,
            height: 12,
          },
          style: { stroke: '#002060', strokeWidth: 2 },
          Level: getLevelKey(currentLevel, currentParentId),
          user_id: user && user.id,
          Process_id: id && id,
          page_title: 'Swimlane',
          status: 'draft',
        };

        setEdges((eds) => addEdge(newEdge, eds));
        setHasUnsavedChanges(true);
        setDrawingEdge(null);
        return;
      }

      if (e.button === 0) {
        setDrawingEdge((prev) => {
          if (!prev) return null;
          return {
            ...prev,
            waypoints: [...prev.waypoints, prev.currentCursor],
          };
        });
      }
    };

    window.addEventListener('click', handleClick, true);
    return () => window.removeEventListener('click', handleClick, true);
  }, [drawingEdge, setEdges, currentLevel, currentParentId, user, id, setHasUnsavedChanges]);

  const onConnectStart = useCallback(
    (event, { nodeId, handleId, handleType }) => {
      ensureZeroViewport();
      if (activeMode !== 'edit') return;

      const handleEl = event.target.closest('.react-flow__handle');
      if (!handleEl) return;

      const rect = handleEl.getBoundingClientRect();
      const handleCenterX = rect.left + rect.width / 2;
      const handleCenterY = rect.top + rect.height / 2;
      const flowStart = screenToFlowPosition({ x: handleCenterX, y: handleCenterY });
      const handlePos = handleId?.split('-')[0] || 'bottom';

      setDrawingEdge({
        source: nodeId,
        sourceHandle: handleId,
        sourceHandleType: handleType,
        sourcePosition: handlePos,
        sourceX: flowStart.x,
        sourceY: flowStart.y,
        waypoints: [],
        currentCursor: flowStart,
      });
    },
    [activeMode, screenToFlowPosition, ensureZeroViewport]
  );

  const onConnectEnd = useCallback(() => {
    setDrawingEdge(null);
    ensureZeroViewport();
  }, [ensureZeroViewport]);

  const displayNodes = useMemo(() => {
    const cleanedChildNodes = ChildNodes.map((child) => {
      if (child.extent !== undefined || child.parentId !== undefined) {
        const { extent, parentId, ...rest } = child;
        return rest;
      }
      return child;
    });
    const allNodes = [...nodes, ...cleanedChildNodes];
    if (drawingEdge && drawingEdge.currentCursor) {
      allNodes.push({
        id: 'temp-target-node',
        type: 'dummy',
        position: drawingEdge.currentCursor,
        style: { width: 0, height: 0, opacity: 0, pointerEvents: 'none' },
        data: {},
      });
    }
    return allNodes;
  }, [nodes, ChildNodes, drawingEdge]);

  const displayEdges = useMemo(() => {
    const allEdges = edges.map((edge) => ({
      ...edge,
      data: {
        ...edge.data,
        activeMode: activeMode,
        setEdges: setEdges,
      },
    }));
    if (drawingEdge && drawingEdge.currentCursor) {
      const lastWp = drawingEdge.waypoints[drawingEdge.waypoints.length - 1];
      const startPoint = lastWp || { x: drawingEdge.sourceX, y: drawingEdge.sourceY };

      let targetPosition = 'left';
      const dx = drawingEdge.currentCursor.x - startPoint.x;
      const dy = drawingEdge.currentCursor.y - startPoint.y;
      if (Math.abs(dx) > Math.abs(dy)) {
        targetPosition = dx > 0 ? 'left' : 'right';
      } else {
        targetPosition = dy > 0 ? 'top' : 'bottom';
      }

      allEdges.push({
        id: 'temp-preview-edge',
        source: drawingEdge.source,
        sourceHandle: drawingEdge.sourceHandle,
        target: 'temp-target-node',
        targetHandle: `${targetPosition}-target`,
        type: 'waypointEdge',
        data: {
          waypoints: drawingEdge.waypoints,
          activeMode: 'edit',
          isPreview: true,
        },
        style: {
          stroke: '#002060',
          strokeWidth: 2,
          strokeDasharray: '5,5',
        },
      });
    }
    return allEdges;
  }, [edges, drawingEdge, activeMode, setEdges]);

  useEffect(() => {
    if (initialNodes?.nodes) {
      setNodes(initialNodes.nodes);
    }
  }, [initialNodes, setNodes]);

  const headerTitle = `${title} `;
  const menuWidth = 180;
  const menuHeight = 160;

  // compute position relative to .publishcontainer
  const fixedPos = getDropdownPosition(position.x, position.y, menuWidth, menuHeight);

  const ChildNodesRef = useRef(ChildNodes);
  useEffect(() => {
    ChildNodesRef.current = ChildNodes;
  }, [ChildNodes]);

  const isInitialLoad = useRef(true);
  const edgeTypes = useMemo(
    () => ({
      default: WaypointEdge,
      smoothstep: WaypointEdge,
      bezier: BezierEdge,
      straight: StraightEdge,
      step: WaypointEdge,
      waypointEdge: WaypointEdge,
    }),
    []
  );

  const processLangRef = useRef(processDefaultlanguage_id);
  const langMapRef = useRef(langMap);

  useEffect(() => {
    processLangRef.current = processDefaultlanguage_id;
    langMapRef.current = langMap;
  }, [processDefaultlanguage_id, langMap]);

  const { handleLabelChange } = useSwimlaneLabelChange({
    setChiledNodes,
    setHasUnsavedChanges,
    processLangRef,
    langMapRef,
    isInitialLoad,
  });

  useCheckFavorite({
    id,
    childNodes: ChildNodes,
    setIsFavorite,
  });

  const { pendingApproval, refetch: refetchApprovalStatus } = useApprovalStatus({
    processId: id,
    currentLevel,
    currentParentId,
    mode: activeMode,
  });

  const nodesRef = useRef(nodes);
  useEffect(() => {
    nodesRef.current = nodes;
  }, [nodes]);

  const setChildNodesWithCentering = useCallback(
    (nodesOrUpdater) => {
      const currentGridNodes =
        nodesRef.current && nodesRef.current.length > 0
          ? nodesRef.current
          : initialNodes?.nodes || [];

      setChiledNodes((prev) => {
        const nextNodes =
          typeof nodesOrUpdater === 'function' ? nodesOrUpdater(prev) : nodesOrUpdater;
        if (!Array.isArray(nextNodes)) return nextNodes;

        return nextNodes.map((child) => {
          if (
            child.type === 'StickyNote' ||
            child.type === 'Yes' ||
            child.type === 'No' ||
            child.type === 'FreeText'
          ) {
            return child;
          }

          const parentId =
            child.parentNode || child.parentId || child.parent_id || child.data?.parentId;
          const parentNode = parentId ? currentGridNodes.find((n) => n.id === parentId) : null;

          if (parentNode) {
            const centered = centerChildInParent(parentNode, child);
            return {
              ...child,
              parentId: undefined,
              extent: undefined,
              parentNode: parentNode.id,
              position: centered,
            };
          }
          return {
            ...child,
            parentId: undefined,
            extent: undefined,
          };
        });
      });
    },
    [initialNodes, setChiledNodes]
  );

  const versionData = useSwimlaneVersionData({
    processId: id,
    level,
    version,
    currentParentId,
    setChiledNodes: setChildNodesWithCentering,
    setEdges,
    setSupportedLanguages,
    setprocessDefaultlanguage_id,
    setOriginalDefaultLanguageId: setOriginalDefaultlanguge_id,
    SetcurrentModeltitle: Settitle,
    SetTitle: () => {},
  });

  const {
    contactInfo,
    revisionInfo,
    assignedUsers: versionAssignedUsers,
    versionStatus,
    versionDate,
    processImg,
    fetchVersionData,
    handleLanguageSwitch: handleVersionLanguageSwitch,
  } = versionData;

  const approvals = useSwimlaneApprovals({
    processId: id,
    currentLevel,
    currentParentId,
    LoginUser,
    title,
    t,
    refetchApprovalStatus,
  });

  const {
    editScheduledModalOpen,
    setEditScheduledModalOpen,
    requestChangeModalOpen,
    setRequestChangeModalOpen,
    handleApproveProcess,
    handleCancelPublishing,
    handleReschedulePublishing,
    handleContentChangeRequest,
    handleCancelApproval,
  } = approvals;

  const approvalStatus = pendingApproval?.approval?.status;

  useEffect(() => {
    if (activeMode === 'edit' && (approvalStatus === 0 || (user && user.role === 'User'))) {
      goToProcess({
        mode: 'draft',
        view: 'swimlane',
        processId,
        level: currentLevel,
        parentId: currentParentId || undefined,
      });
    }
  }, [activeMode, approvalStatus, user, goToProcess, processId, currentLevel, currentParentId]);

  const { responseData, refetch } = useFetchVersions({
    processId: id,
    currentLevel,
    currentParentId,
    LoginUser,
    status: 'draft',
  });

  const latestPublishedVersion = useMemo(() => {
    if (!responseData || !responseData.versions || responseData.versions.length === 0) {
      return '0.x.x';
    }
    const pubVersion = responseData.versions.find(
      (v) => v.change_type && v.change_type !== 'Draft'
    );
    return pubVersion ? pubVersion.version : '0.x.x';
  }, [responseData]);

  const currentVersion = useMemo(() => {
    if (activeMode === 'version') {
      return version;
    }
    if (activeMode === 'published') {
      return latestPublishedVersion !== '0.x.x' ? latestPublishedVersion : '1.0.000';
    }
    if (responseData && responseData.versions && responseData.versions.length > 0) {
      return responseData.versions[0].version;
    }
    return '0.0.001';
  }, [activeMode, version, latestPublishedVersion, responseData]);

  const levelParam =
    level && level.startsWith('level') ? level : getLevelKey(currentLevel, currentParentId);
  const energyMeter = useEnergyMeter(
    processId,
    currentVersion,
    currentVersion,
    levelParam,
    activeMode === 'version'
  );

  const isEnergyMeterAllowed =
    activeMode === 'published' || (activeMode === 'version' && versionStatus === 'Published');
  const assignedUsers =
    activeMode === 'version' ? versionAssignedUsers : responseData?.assigned_users || [];

  const { fetchNodes } = useSwimlaneFetchNodes({
    api,
    mode: activeMode === 'published' ? 'publish' : activeMode === 'draft' ? 'draft' : 'edit',
    getLevelKey,
    currentLevel,
    currentParentId,
    LoginUser,
    id,

    // setters
    setters: {
      setUser,
      setChiledNodes: setChildNodesWithCentering,
      setEdges,
      setprocess_img,
      Settitle,
      SetParentPageGroupId,
      setprocessDefaultlanguage_id,
      setOriginalDefaultlanguge_id,
      setSupportedLanguages,
      setgetPublishedDate,
      setDraftedDate,
    },
    handleLabelChange,
  });

  // Hook for adding nodes
  const { addNode } = useSwimlaneAddNode({
    ChildNodes,
    setChiledNodes,
    nodes,
    currentParentId,
    currentLevel,
    setHasUnsavedChanges,
    handleLabelChange,
    selectedGroupId,
    selectedexistigrolenodeId,
    langMapRef,
    processLangRef,
  });

  // Hook for dragging
  const { handleNodeDragStart, handleNodeDragStop } = useSwimlaneDrag({
    setChiledNodes,
    setKeepOldPosition,
    KeepOldPosition,
    nodes,
    ChildNodes,
    setHasUnsavedChanges,
  });

  const { removeBreadcrumbsAfter, addBreadcrumb, breadcrumbs, setBreadcrumbs } =
    useContext(BreadcrumbsContext);

  const handlers = useSwimlaneModelHandlers({
    state,
    currentLevel,
    currentParentId,
    processId,
    LoginUser,
    addNode,
    fetchNodes,
    goToProcess,
    addBreadcrumb,
    removeBreadcrumbsAfter,
    langMap,
    t,
    navigate,
    fixedPos,
    id,
    refetch,
    safeRemainingHeight,
  });

  useEffect(() => {
    if (activeMode === 'version') {
      fetchVersionData(processDefaultlanguage_id);
    } else {
      fetchNodes(processDefaultlanguage_id);
      if (LoginUser?.id) handlers.fetchExistingRoles();
    }
  }, [
    activeMode,
    version,
    currentLevel,
    setNodes,
    setEdges,
    LoginUser,
    currentParentId,
    id,
    // windowSize,
    processDefaultlanguage_id,
  ]);

  useEffect(() => {
    if (showRoleGroupModal) {
      handlers.fetchExistingRoles();
    }
  }, [showRoleGroupModal]);

  const onNodesChange = useCallback(
    (changes) => setChiledNodes((nds) => applyNodeChanges(changes, nds)),
    [setChiledNodes]
  );

  const onEdgesChange = useCallback(
    (changes) => {
      setEdges((eds) => {
        const remainingEdges = applyEdgeChanges(changes, eds);

        // Check for removed edges
        const removedEdges = changes
          .filter((change) => change.type === 'remove')
          .map((change) => {
            const edge = eds.find((e) => String(e.id) === String(change.id));
            return edge
              ? {
                  id: edge.id,
                  source: edge.source,
                  target: edge.target,
                  sourceHandle: edge.sourceHandle,
                  targetHandle: edge.targetHandle,
                }
              : null;
          })
          .filter(Boolean);

        if (removedEdges.length > 0) {
          setChiledNodes((prevNodes) =>
            prevNodes.filter((node) => {
              if (!node.data?.edgeId && !node.data?.sourceNodeId) return true;
              return !removedEdges.some(
                (edge) =>
                  String(edge.id) === String(node.data.edgeId) ||
                  (String(edge.source) === String(node.data.sourceNodeId) &&
                    String(edge.target) === String(node.data.targetNodeId) &&
                    String(edge.sourceHandle || '') === String(node.data.sourceHandle || '') &&
                    String(edge.targetHandle || '') === String(node.data.targetHandle || ''))
              );
            })
          );
        }

        return remainingEdges;
      });
    },
    [setEdges, setChiledNodes]
  );

  const onNodesDelete = useCallback(
    (deletedNodes) => {
      const removedEdgeIds = new Set();
      const removedEdgeDetails = [];

      deletedNodes.forEach((node) => {
        edges.forEach((edge) => {
          if (String(edge.source) === String(node.id) || String(edge.target) === String(node.id)) {
            removedEdgeIds.add(String(edge.id));
            removedEdgeDetails.push({
              source: edge.source,
              target: edge.target,
              sourceHandle: edge.sourceHandle,
              targetHandle: edge.targetHandle,
            });
          }
        });
      });

      if (removedEdgeDetails.length > 0 || removedEdgeIds.size > 0) {
        setChiledNodes((prevNodes) =>
          prevNodes.filter((node) => {
            if (!node.data?.edgeId && !node.data?.sourceNodeId) return true;
            return !(
              removedEdgeIds.has(String(node.data.edgeId)) ||
              removedEdgeDetails.some(
                (edge) =>
                  String(edge.source) === String(node.data.sourceNodeId) &&
                  String(edge.target) === String(node.data.targetNodeId) &&
                  String(edge.sourceHandle || '') === String(node.data.sourceHandle || '') &&
                  String(edge.targetHandle || '') === String(node.data.targetHandle || '')
              )
            );
          })
        );
      }
    },
    [edges, setChiledNodes]
  );

  const onConnect = useCallback(
    (params) => {
      setDrawingEdge(null);
      ensureZeroViewport();
      setEdges((eds) =>
        addEdge(
          {
            ...params,
            markerEnd: {
              type: MarkerType.ArrowClosed,
              color: '#002060',
              width: 12,
              height: 12,
            },
            style: { stroke: '#002060', strokeWidth: 2 },

            Level: getLevelKey(currentLevel, currentParentId),

            user_id: user && user.id,
            Process_id: id && id,
            type: 'waypointEdge',
            data: { waypoints: [] },
            page_title: 'Swimlane',
            status: 'draft',
          },
          eds
        )
      );
      setHasUnsavedChanges(true);
    },
    [setEdges, currentLevel, currentParentId, user, id, ensureZeroViewport]
  );

  useEffect(() => {
    const checkpublishfunction = async () => {
      if (activeMode === 'edit') {
        if (currentLevel !== 0 && currentParentId) {
          try {
            const response = await checkParentPublishRecords(currentParentId, processId);
            Setcheckpublish(response?.status === true);
          } catch (error) {
            logger.error('filter draft error', error);
          }
        } else if (currentLevel === 0) {
          Setcheckpublish(true);
        }
      } else if (activeMode === 'draft') {
        try {
          const data = await checkPublishRecord(
            getLevelKey(currentLevel, currentParentId),
            processId
          );
          Setcheckpublish(data?.status);
        } catch (error) {
          logger.error('checkPublishRecord error', error);
        }
      }
    };
    checkpublishfunction();
  }, [currentParentId, currentLevel, processId, activeMode, Setcheckpublish]);

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Allow scrolling the page when scrolling over the swimlane canvas
  useEffect(() => {
    const handleCanvasWheel = (e) => {
      // If user is already scrolling horizontally (trackpad/tilt) or holding Shift or Ctrl (zoom)
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY) || e.shiftKey || e.ctrlKey) {
        return;
      }
      const maxScrollY = document.documentElement.scrollHeight - window.innerHeight;
      const maxScrollX = document.documentElement.scrollWidth - window.innerWidth;
      // If page has horizontal room and little vertical room, scroll horizontally with mouse wheel
      if (maxScrollX > 0 && maxScrollY <= 20) {
        window.scrollBy({ left: e.deltaY, behavior: 'auto' });
      }
    };

    const container = document.querySelector('.custom_swimlane');
    if (container) {
      container.addEventListener('wheel', handleCanvasWheel, { passive: true });
    }
    return () => {
      if (container) {
        container.removeEventListener('wheel', handleCanvasWheel);
      }
    };
  }, []);

  const currentLangCode = langMap[processDefaultlanguage_id] || 'de';

  const memoizedNodeTypes = useMemo(() => {
    const isEdit = activeMode === 'edit';
    return {
      progressArrow: (props) => (
        <SwimlaneArrowBoxNode
          {...props}
          mode={activeMode}
          editable={isEdit}
          langCode={currentLangCode}
        />
      ),
      box: (props) => <SwimlaneBoxNode {...props} editable={isEdit} langCode={currentLangCode} />,
      diamond: (props) => (
        <SwimlaneDiamondNode {...props} editable={isEdit} langCode={currentLangCode} />
      ),
      SwimlineRightsideBox: (props) => (
        <SwimlaneRightsideBox
          {...props}
          editable={isEdit}
          processDefaultlanguage_id={processLangRef.current}
          langMap={langMapRef.current}
          langCode={currentLangCode}
        />
      ),
      FreeText: FreeTextNode,
      StickyNote: (props) => <StickyNote {...props} editable={isEdit} />,
      Yes: (props) => (
        <YesNode
          {...props}
          processDefaultlanguage_id={processLangRef.current}
          langCode={currentLangCode}
        />
      ),
      No: (props) => (
        <NoNode
          {...props}
          processDefaultlanguage_id={processLangRef.current}
          langCode={currentLangCode}
        />
      ),
      dummy: () => null,
    };
  }, [activeMode, currentLangCode]);

  const memoizedEdgeTypes = useMemo(() => edgeTypes, [edgeTypes]);

  const parsedData = LinknodeList.map((item) => ({
    ...item,
    data: JSON.parse(item.data), // Parse the data field
  }));

  const langKey = langMap[processDefaultlanguage_id] || 'EN';

  const translatedData = parsedData.map((item) => {
    const { translations = {}, label = '' } = item.data || {};
    const newLabel = translations[langKey] || label;

    return {
      ...item,
      data: {
        ...item.data,
        label: newLabel,
      },
    };
  });

  const filteredData = translatedData.filter(
    (item) => item.data.label && item.data.label.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const parsedDataExistingrole = LinkexistingRole.map((item) => ({
    ...item,
    data: typeof item.data === 'string' ? JSON.parse(item.data) : item.data,
  }));

  const filteredDataExistingrole = parsedDataExistingrole.filter(
    (item) =>
      item.data?.details?.title &&
      item.data.details.title.toLowerCase().includes(ExistingrolesearchQuery.toLowerCase())
  );

  const menuItems = [
    ...(detailschecking?.type !== 'SwimlineRightsideBox' &&
    detailschecking?.type !== 'progressArrow' &&
    detailschecking?.type !== 'Yes' &&
    detailschecking?.type !== 'No' &&
    detailschecking?.type !== 'FreeText' &&
    detailschecking?.type !== 'StickyNote'
      ? [
          {
            label:
              detailschecking &&
              (!detailschecking?.data?.details?.title ||
                detailschecking?.data?.details?.title === '') &&
              (!detailschecking?.data?.details?.content ||
                detailschecking?.data?.details?.content === '')
                ? `${t('add_details')}`
                : `${t('edit_details')}`,
            action: () => handlers.handlePopupAction('addDetails'),
            borderBottom: true,
          },
        ]
      : []),
    ...(detailschecking?.type === 'box'
      ? [
          {
            label: `${t('switch_shape_to_decision')}`,
            action: () => handlers.switchNodeType('diamond'),
            borderBottom: true,
          },
        ]
      : []),
    ...(detailschecking?.type === 'diamond'
      ? [
          {
            label: `${t('switch_shape_to_activity')}`,
            action: () => handlers.switchNodeType('box'),
            borderBottom: true,
          },
        ]
      : []),
    ...(detailschecking?.type === 'progressArrow'
      ? [
          ...(detailschecking?.data?.processlink
            ? [
                {
                  label: `${t('open_existing_model')}`,
                  action: () => handlers.openExistingModel(detailschecking?.data?.processlink),
                  borderBottom: true,
                },
                {
                  label: `${t('remove_existing_model')}`,
                  action: () => handlers.removeExistingLink(),
                  borderBottom: true,
                },
              ]
            : [
                {
                  label: `${t('link_existing_model')}`,
                  action: () => handlers.linkExistingmodel(),
                  borderBottom: true,
                },
              ]),
        ]
      : []),

    ...(detailschecking?.type === 'FreeText'
      ? [
          {
            label: `${t('edit_text')}`,
            action: () => handlers.UpdateText(),
            borderBottom: true,
          },
        ]
      : []),

    ...(detailschecking?.type !== 'Yes' && detailschecking?.type !== 'No'
      ? [
          {
            label: `${t('translation')}`,
            action: handlers.translation,
            borderBottom: false,
          },
        ]
      : []),

    ...(detailschecking?.type === 'SwimlineRightsideBox'
      ? [
          {
            label: t('assign_role_owner'),
            action: () => handlers.handleAssignOwnerAction(detailschecking),
            borderBottom: true,
          },
          ...(detailschecking?.data?.isRoleGroup
            ? [
                {
                  label: t('manage_role_group'),
                  action: () => setShowRoleGroupModal(true),
                  borderBottom: true,
                },
              ]
            : []),
        ]
      : []),

    {
      label: `${t('Delete')}`,
      action: handlers.handleDeleteNode,
      borderBottom: false,
    },
  ];

  const iconNames = {};

  const handleSave = (savetype) => {
    if (activeMode === 'edit') {
      handlers.handleSaveNodes(savetype || 'draft');
    } else if (activeMode === 'draft') {
      if (!id) {
        CustomAlert.warning(t('warning') || 'Warning', 'Currently not navigate on draft mode');
        return;
      }
      const targetMode = savetype === 'editdraft' ? 'edit' : 'published';
      const updatedBreadcrumbs = breadcrumbs.map((crumb, index) => {
        if (index === 0 || !crumb.path) return crumb;
        let newPath = crumb.path;
        if (savetype === 'editdraft') {
          newPath = crumb.path.replace('/published/', '/edit/').replace('/draft/', '/edit/');
        } else {
          newPath = crumb.path.replace('/edit/', '/published/').replace('/draft/', '/published/');
        }
        return {
          ...crumb,
          path: newPath,
        };
      });
      setBreadcrumbs(updatedBreadcrumbs);
      goToProcess({
        mode: targetMode,
        view: 'swimlane',
        processId: id,
        level: currentLevel,
        parentId: currentLevel === 0 ? undefined : currentParentId,
      });
    } else if (activeMode === 'published') {
      if (!id) {
        CustomAlert.warning(t('warning') || 'Warning', 'Currently not navigate on draft mode');
        return;
      }
      const targetMode = savetype === 'draft' ? 'draft' : 'edit';
      const updatedBreadcrumbs = breadcrumbs.map((crumb, index) => {
        if (index === 0 || !crumb.path) return crumb;
        let newPath = crumb.path;
        if (savetype === 'draft') {
          newPath = crumb.path.replace('/published/', '/draft/').replace('/edit/', '/draft/');
        } else {
          newPath = crumb.path.replace('/published/', '/edit/').replace('/draft/', '/edit/');
        }
        return {
          ...crumb,
          path: newPath,
        };
      });
      setBreadcrumbs(updatedBreadcrumbs);
      goToProcess({
        mode: targetMode,
        view: 'swimlane',
        processId: id,
        level: currentLevel,
        parentId: currentLevel === 0 ? undefined : currentParentId,
      });
    }
  };

  const handleBackdata = async () => {
    if (activeMode === 'version') {
      navigate(-1);
      return true;
    } else if (activeMode === 'edit') {
      return await handlers.handleExitBack();
    } else {
      return true;
    }
  };

  const headerPageName =
    activeMode === 'version'
      ? 'ViewProcessmapVersion'
      : activeMode === 'published'
        ? 'ViewPublishswimlane'
        : activeMode === 'draft'
          ? 'ViewDraftswimlane'
          : 'Swimlane';

  const headerPublishedDate =
    activeMode === 'version'
      ? versionStatus === 'Published'
        ? versionDate
        : null
      : activeMode === 'draft'
        ? null
        : getPublishedDate;

  const headerDraftedDate =
    activeMode === 'version'
      ? versionStatus !== 'Published'
        ? versionDate
        : null
      : getDraftedDate;

  const headerProcessImg = activeMode === 'version' ? processImg : process_img;

  const handleSupportViewlangugeId =
    activeMode === 'version'
      ? handleVersionLanguageSwitch
      : (langId) => {
          handlers.handleLanguageSwitch(langId);
          if (activeMode !== 'edit') {
            fetchNodes(langId);
          }
        };

  const handleShowVersion = () => {
    if (activeMode === 'edit') {
      handlers.handleVersionClick();
    } else {
      setShowVersionPopup(true);
    }
  };

  const handleFav = async () => {
    if (activeMode === 'edit') {
      handlers.handleFav();
      return;
    }
    const process_id = id ? id : null;
    const type = user ? user.type : null;

    if (!process_id || !type) {
      logger.error('Missing required fields:', { process_id, type });
      return;
    }

    const PageGroupId = ChildNodes[0]?.page_group_id;

    try {
      if (isFavorite) {
        await removeFavProcess(process_id, PageGroupId);
        setIsFavorite(false);
      } else {
        await addFavProcess(process_id, type, PageGroupId, currentParentId);
        setIsFavorite(true);
      }
    } catch (error) {
      logger.error('Favorite toggle error:', error);
    }
  };

  const flowAppContainerClassName =
    activeMode === 'edit' ? 'maincontainer publishcontainer' : 'publishcontainer';

  const flowContentWrapperClassName =
    activeMode === 'edit' ? 'scrollbar_wrapper' : 'ss_publish_border scrollbar_wrapper';

  const flowContentWrapperStyle =
    activeMode === 'edit'
      ? styles.scrollableWrapper
      : { ...styles.scrollableWrapper, position: 'relative' };

  const watermarkText =
    activeMode === 'draft' || activeMode === 'edit'
      ? t('Draft')
      : activeMode === 'version'
        ? t('Archive')
        : undefined;

  return (
    <div dir="ltr">
      <Header
        savefav={handleFav}
        title={activeMode === 'version' ? `${title} (Version: ${version})` : headerTitle}
        onSave={activeMode === 'version' ? undefined : handleSave}
        onPublish={activeMode === 'edit' ? handlers.handleSavePublish : undefined}
        addNode={activeMode === 'edit' ? addNode : undefined}
        handleBackdata={handleBackdata}
        iconNames={iconNames}
        getPublishedDate={headerPublishedDate}
        getDraftedDate={headerDraftedDate}
        setIsNavigating={() => removeBreadcrumbsAfter(currentLevel - 1)}
        Page={headerPageName}
        onExit={activeMode === 'edit' ? handlers.ExitNavigation : undefined}
        isFavorite={isFavorite}
        Process_img={headerProcessImg}
        Procesuser={user}
        checkpublish={checkpublish}
        onShowVersion={handleShowVersion}
        handleSupportViewlangugeId={handleSupportViewlangugeId}
        supportedLanguages={supportedLanguages}
        selectedLanguage={processDefaultlanguage_id}
        OriginalDefaultlanguge_id={OriginalDefaultlanguge_id}
        revisionresponse={responseData}
        onApproveProcess={activeMode === 'draft' ? handleApproveProcess : undefined}
        onRequestChange={activeMode === 'draft' ? () => setRequestChangeModalOpen(true) : undefined}
        pendingApproval={pendingApproval}
        onCancelPublishing={activeMode === 'draft' ? handleCancelPublishing : undefined}
        onEditScheduled={activeMode === 'draft' ? () => setEditScheduledModalOpen(true) : undefined}
        onCancelApproval={activeMode === 'draft' ? handleCancelApproval : undefined}
        processId={processId}
        energyMeterActive={isEnergyMeterAllowed && energyMeter.active}
        energyMeterHotspotCount={isEnergyMeterAllowed ? energyMeter.hotspotCount : undefined}
        onToggleEnergyMeter={isEnergyMeterAllowed ? energyMeter.toggleEnergyMeter : undefined}
      />

      <ProcessMapFlow
        nodes={displayNodes}
        edges={displayEdges}
        nodesDraggable={activeMode === 'edit'}
        nodesConnectable={activeMode === 'edit'}
        autoPanOnConnect={false}
        autoPanOnNodeDrag={false}
        panOnDrag={false}
        panOnScroll={false}
        preventScrolling={false}
        onNodesChange={activeMode === 'edit' ? onNodesChange : undefined}
        onEdgesChange={activeMode === 'edit' ? onEdgesChange : undefined}
        onConnectStart={onConnectStart}
        onConnectEnd={onConnectEnd}
        onNodeClick={activeMode === 'edit' ? handlers.handleNodeClick : undefined}
        nodeTypes={memoizedNodeTypes}
        edgeTypes={memoizedEdgeTypes}
        safeRemainingHeight={safeRemainingHeight}
        showPageGroupIdViewer={true}
        nodesForPageGroupId={ChildNodes}
        energyMeter={isEnergyMeterAllowed ? energyMeter : undefined}
        processId={processId}
        fitView={false}
        showBackground={false}
        // Custom classes/styles
        appContainerClassName={flowAppContainerClassName}
        appContainerStyle={styles.appContainer}
        contentWrapperClassName={flowContentWrapperClassName}
        contentWrapperStyle={flowContentWrapperStyle}
        className="custom_swimlane"
        flowContainerClassName=""
        flowContainerStyle={{ border: 'none', padding: 0 }}
        // ReactFlow props passed through
        onNodesDelete={activeMode === 'edit' ? onNodesDelete : undefined}
        onConnect={activeMode === 'edit' ? onConnect : undefined}
        onNodeContextMenu={activeMode === 'edit' ? handlers.handleNodeRightClick : undefined}
        onReconnect={activeMode === 'edit' ? handlers.onReconnect : undefined}
        onPaneContextMenu={activeMode === 'edit' ? handlers.handleContextMenu : undefined}
        onEdgeContextMenu={activeMode === 'edit' ? handlers.onEdgeClick : undefined}
        onNodeDragStart={activeMode === 'edit' ? handleNodeDragStart : undefined}
        onNodeDragStop={activeMode === 'edit' ? handleNodeDragStop : undefined}
        connectionLineComponent={CustomConnectionLine}
        connectionRadius={10}
        connectionMode={ConnectionMode.Loose}
        minZoom={0}
        maxZoom={1}
        zoomOnDoubleClick={false}
        defaultEdgeOptions={{ zIndex: 1 }}
        style={{
          ...styles.rfStyle,
          direction: 'ltr', // Keep internal coordinates LTR
        }}
        backgroundColor="#fff"
        backgroundGap={16}
        watermarkText={watermarkText}
      >
        {activeMode === 'edit' && (
          <EdgeContextMenu
            visible={!!selectedEdge}
            position={fixedPos}
            t={t}
            onAction={handlers.handlePopupAction}
            onDelete={handlers.deleteEdge}
          />
        )}

        <SwimlaneModals
          activeMode={activeMode}
          MenuVisible={MenuVisible}
          contextMenu={contextMenu}
          menuItems={menuItems}
          handlers={handlers}
          showPublishPopup={showPublishPopup}
          setShowPublishPopup={setShowPublishPopup}
          responseData={responseData}
          processDefaultlanguage_id={processDefaultlanguage_id}
          supportedLanguages={supportedLanguages}
          OriginalDefaultlanguge_id={OriginalDefaultlanguge_id}
          showEditorialPopup={showEditorialPopup}
          setShowEditorialPopup={setShowEditorialPopup}
          showContentPopup={showContentPopup}
          setShowContentPopup={setShowContentPopup}
          isPopupOpen={isPopupOpen}
          setIsPopupOpen={setIsPopupOpen}
          selectedNodeId={selectedNodeId}
          setSelectedNodeId={setSelectedNodeId}
          ChildNodes={ChildNodes}
          isCheckboxPopupOpen={isCheckboxPopupOpen}
          t={t}
          popupStyle={popupStyle}
          styles={styles}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          filteredData={filteredData}
          selectedLinknodeIds={selectedLinknodeIds}
          isexistingroleCheckboxPopupOpen={isexistingroleCheckboxPopupOpen}
          ExistingrolesearchQuery={ExistingrolesearchQuery}
          setExistingrolesearchQuery={setExistingrolesearchQuery}
          filteredDataExistingrole={filteredDataExistingrole}
          selectedexistigrolenodeId={selectedexistigrolenodeId}
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          modalText={modalText}
          options={options}
          position={position}
          showTranslationPopup={showTranslationPopup}
          setShowTranslationPopup={setShowTranslationPopup}
          translationDefaults={translationDefaults}
          showVersionPopup={showVersionPopup}
          setShowVersionPopup={setShowVersionPopup}
          id={id}
          currentLevel={currentLevel}
          currentParentId={currentParentId}
          LoginUser={LoginUser}
          headerTitle={headerTitle}
          versionPopupPayload={versionPopupPayload}
          showRoleGroupModal={showRoleGroupModal}
          setShowRoleGroupModal={setShowRoleGroupModal}
          setRoleGroupEditData={setRoleGroupEditData}
          roleGroupEditData={roleGroupEditData}
          langMap={langMap}
          parsedDataExistingrole={parsedDataExistingrole}
          assignedUsers={assignedUsers}
          setChiledNodes={setChiledNodes}
          setHasUnsavedChanges={setHasUnsavedChanges}
          showAssignOwnerModal={showAssignOwnerModal}
          setShowAssignOwnerModal={setShowAssignOwnerModal}
          activeRoleForOwner={activeRoleForOwner}
          editScheduledModalOpen={editScheduledModalOpen}
          setEditScheduledModalOpen={setEditScheduledModalOpen}
          pendingApproval={pendingApproval}
          handleCancelPublishing={handleCancelPublishing}
          handleReschedulePublishing={handleReschedulePublishing}
          requestChangeModalOpen={requestChangeModalOpen}
          setRequestChangeModalOpen={setRequestChangeModalOpen}
          handleContentChangeRequest={handleContentChangeRequest}
          contactInfo={contactInfo}
          revisionInfo={revisionInfo}
        />
      </ProcessMapFlow>
    </div>
  );
};

const SwimlaneModel = () => (
  <ReactFlowProvider>
    <SwimlaneModelContent />
  </ReactFlowProvider>
);

export default SwimlaneModel;

const popupStyle = {
  container: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    borderRadius: '8px',
    padding: '16px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    width: '300px',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '8px',
    fontWeight: 'bold',
    fontSize: '12px',
  },
  closeButton: {
    background: 'none',
    border: 'none',
    fontSize: '20px',
    cursor: 'pointer',
  },
  body: {
    marginBottom: '16px',
    maxHeight: '250px',
    overflowY: 'auto',
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '8px',
    padding: '8px',
    borderRadius: '4px',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
  },
  checkbox: {
    marginRight: '8px',
  },
  footer: {
    textAlign: 'right',
  },
  saveButton: {
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    padding: '8px 16px',
    borderRadius: '4px',
    cursor: 'pointer',
  },
};
